
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { auditingNo, medicalDecList, auditing, auditingP } from '@/api/yiliaohuzhu'
export default {
name: 'workspace',
directives: {
TransferDom
},
components: {
XDialog,
XTextarea,
Group
},
data () {
return {
areaid: this.$route.params.areaid,
type: this.$route.params.type,
pageSize: 4,
pageCurrent: 1,
list: [],
checkedid: [],
moremsg: '点击加载更多',
nomore: false,
show: false,
textarea: '',
alllist: [],
qxlist: [],
checked: false
}
},
mounted () {
this.getdeclistNow()
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
watch: {
checkedid: function () {
if (this.checkedid.length == this.alllist.length) {
this.checked = true
} else {
this.checked = false
}
}
},
methods: {
getdeclistNow () {

medicalDecList({
accountid: this.accountid,
medicalType: this.type,
area: this.areaid,
pageSize: this.pageSize,
pageCurrent: this.pageCurrent
}).then(res => {
if (res.obj !== null) {
if (res.obj.length > 0) {
this.checked = false
this.list = [...this.list, ...res.obj]
this.list.forEach(obj => {
this.alllist.push(obj.id)
})
this.alllist = Array.from(new Set(this.alllist))
this.moremsg = '点击加载更多'
} else if (this.pageCurrent == 1 && this.list.length == 0) {
window.history.go(-1)
} else {
this.moremsg = ''
this.nomore = true
}
}
})
},
loadmore () {
if (!this.nomore) {
this.moremsg = '正在加载中...'

this.checkedid = Array.from(new Set(this.checkedid))
this.pageCurrent++
this.getdeclistNow()
}
},
qx () {
if (this.checked) {
this.checkedid = this.alllist
} else {
this.checkedid = []
}
},
audit () {
console.log(this.checkedid)
if (this.checkedid.length == 0) {
this.$vux.alert.show({
content: '您尚未选择！'
})
}
if (this.checkedid.length == 1) {
auditing({
accountid: this.accountid,
id: this.checkedid[0]
}).then(res => {
if (res.success == true) {
this.$vux.alert.show({
content: '审核成功！'
})
location.reload()
}
})
}
if (this.checkedid.length > 1) {
auditingP({
accountid: this.accountid,
ids: this.checkedid
}).then(res => {
if (res.success == true) {
this.$vux.alert.show({
content: '审核成功！'
})
location.reload()
}
})
}
if (this.checked == true) {
auditingP({
accountid: this.accountid,
ids: this.alllist.toString()
}).then(res => {
if (res.success == true) {
this.$vux.alert.show({
content: '审核成功！'
})
location.reload()
}
})
}
},
noaudit () {
console.log(this.checkedid)
if (this.checkedid.length == 0) {
this.$vux.alert.show({
content: '您尚未选择！'
})
}
if (this.checkedid.length == 1) {
this.show = true
}
if (this.checkedid.length > 1) {
this.$vux.alert.show({
content: '只能单个拒绝！'
})
}
},
submit () {
if (this.textarea.length == 0) {
this.$vux.toast.text('请填写拒绝理由')
return false
} else {
auditingNo({
accountid: this.accountid,
id: this.checkedid[0],
appreason: this.textarea
}).then(res => {
if (res.success == true) {
this.show = false
this.$vux.alert.show({
content: '拒绝审核成功！'
})
location.reload()
}
})
}
}

















}
}
